/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  /* --------------------------------------------------------------------
   * Summer Sale 2026 — 2 units per SKU, counted across the whole cart
   *
   * These three products go to 50% off Jul 23–29 and are capped at 2 per
   * order. The Cart Block checkout validation covers checkout, but it can
   * only count quantity per cart LINE. The same product can sit on two
   * lines — one added from the product page, one added by the Rebuy cart
   * upsell — so the line rule on its own lets 2 + 2 = 4 through.
   *
   * This totals each capped product across ALL of its lines and trims the
   * excess back down. It hooks the cart API rather than any UI, so it
   * catches Rebuy's adds as well as the theme's, and it does not touch the
   * upsell widget or the A/B test running on it.
   *
   * TO REMOVE AFTER THE SALE: set CAPPED_HANDLES to an empty array.
   * -------------------------------------------------------------------- */

  var CAP_LIMIT = 2;
  var CAPPED_HANDLES = [
    'gentle-detangling-brush', // Detangling Brush & Scalp Massager
    'satin-sleep-bonnet',      // Satin Sleep Cap
    'wooden-detangling-comb'   // Wooden Detangling Comb
  ];
  var CAP_MESSAGE = 'Limit 2 per item during the Summer Sale.';

  if (CAPPED_HANDLES.length) {
    var cartRoot = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    var cartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/;

    // Guards against our own corrective calls re-triggering the watcher.
    var correcting = false;

    var getCart = function() {
      return fetch(cartRoot + '.js', {credentials: 'same-origin'}).then(function(r) { return r.json(); });
    };

    var setLineQuantity = function(key, quantity) {
      return fetch(cartRoot + '/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: quantity})
      });
    };

    var showCapMessage = function() {
      var existing = document.querySelector('[data-sale-cap-message]');
      if (existing) { existing.remove(); }
      var toast = document.createElement('div');
      toast.setAttribute('data-sale-cap-message', '');
      toast.setAttribute('role', 'status');
      toast.textContent = CAP_MESSAGE;
      toast.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
        'z-index:2147483647;max-width:90vw;padding:12px 18px;border-radius:4px;' +
        'background:#1c1c1c;color:#fff;font-size:14px;line-height:1.4;text-align:center;' +
        'box-shadow:0 2px 12px rgba(0,0,0,.25);';
      document.body.appendChild(toast);
      setTimeout(function() { toast.remove(); }, 5000);
    };

    // Total each capped product across every line it occupies, then trim
    // from the most recently added line backwards until it sits at the cap.
    var enforceCaps = function() {
      if (correcting) { return; }
      correcting = true;

      return getCart().then(function(cart) {
        var trims = [];

        CAPPED_HANDLES.forEach(function(handle) {
          var lines = cart.items.filter(function(item) { return item.handle === handle; });
          var total = lines.reduce(function(sum, item) { return sum + item.quantity; }, 0);
          var excess = total - CAP_LIMIT;
          if (excess <= 0) { return; }

          lines.slice().reverse().forEach(function(line) {
            if (excess <= 0) { return; }
            var take = Math.min(excess, line.quantity);
            excess -= take;
            trims.push({key: line.key, quantity: line.quantity - take});
          });
        });

        if (!trims.length) { return false; }

        return trims.reduce(function(chain, trim) {
          return chain.then(function() { return setLineQuantity(trim.key, trim.quantity); });
        }, Promise.resolve()).then(function() { return true; });
      }).then(function(trimmed) {
        correcting = false;
        if (trimmed) {
          showCapMessage();
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        }
      }).catch(function() {
        correcting = false;
      });
    };

    // Watch the cart API itself, so every entry point is covered: the theme,
    // the Rebuy upsell, and the cart page quantity steppers.
    var nativeFetch = window.fetch;
    window.fetch = function(input) {
      var url = (input && input.url) || input || '';
      var request = nativeFetch.apply(this, arguments);
      if (typeof url === 'string' && cartMutation.test(url) && !correcting) {
        request.then(function() { enforceCaps(); }).catch(function() {});
      }
      return request;
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._watchedCartMutation = typeof url === 'string' && cartMutation.test(url);
      return nativeOpen.apply(this, arguments);
    };

    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      if (this._watchedCartMutation) {
        this.addEventListener('load', function() {
          if (!correcting) { enforceCaps(); }
        });
      }
      return nativeSend.apply(this, arguments);
    };

    // Catch carts that were already over the cap before this loaded.
    document.addEventListener('DOMContentLoaded', enforceCaps);
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
